import { EventDispatcher } from 'three';

export class AbstractDomComponent extends EventDispatcher {
    #parentNode;
    #elements;
    _needListeners = false;

    renderTo(parentNode) {
        const elements = this._render(parentNode);

        this.#parentNode = parentNode;

        if (!(elements instanceof Array)) {
            throw new Error('Method _render must return an array of elements.');
        }

        this.#elements = elements;

        if (this._needListeners) {
            requestAnimationFrame(() => {
                this._addListeners();
            });
        }
    }

    appendTo(parentNode) {
        if (!this.#elements || this.#elements.length < 1) {
            this.renderTo(parentNode);

            return;
        }

        this.#elements.forEach((el) => {
            parentNode.appendChild(el);
        });

        this.#parentNode = parentNode;

        if (this._needListeners) {
            requestAnimationFrame(() => {
                this._addListeners();
            });
        }
    }

    remove(clear) {
        if (!this.#elements || this.#elements.length < 1 || !this.parentNode) return;

        if (this._needListeners) this._removeListeners();

        this.#elements.forEach((el) => {
            this.parentNode.removeChild(el);
        });
        this.#parentNode = null;
        if (clear) this.#elements = null;
    }

    // eslint-disable-next-line class-methods-use-this
    _render() {
        // Override this method completely to fulfill template rendering
        // PARAMETERS ORDER:
        // parentNode
        throw new Error('Method _render of AbstractDomComponent must be overridden.');
    }

    // eslint-disable-next-line class-methods-use-this
    _addListeners() {
        // Override this method to make elements interactive
    }

    // eslint-disable-next-line class-methods-use-this
    _removeListeners() {
        // Override this method to remove all the listeners associated
    }

    get parentNode() {
        return this.#parentNode;
    }
}
